import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type GoogleAnalyticsIconProps = React.ComponentPropsWithRef<'svg'>;

export function GoogleAnalyticsIcon({ ...restProps }: GoogleAnalyticsIconProps) {
    const { isDarkMode } = useDarkMode();

    if (isDarkMode()) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <g clipPath="url(#clip0_115_4005)">
                    <path
                        d="M22.84 2.99819V20.9969C22.8486 22.6442 21.5203 23.9866 19.873 23.9953C19.7501 23.9959 19.6273 23.989 19.5053 23.9745C17.9773 23.7485 16.8576 22.4187 16.8948 20.8745V3.12039C16.8579 1.57459 17.9804 0.244186 19.5105 0.0203858C21.1466 -0.171114 22.6283 0.999986 22.8198 2.63619C22.8338 2.75629 22.8406 2.87729 22.84 2.99819ZM4.1326 18.0548C2.4909 18.0548 1.16 19.3858 1.16 21.0274C1.16 22.6691 2.4909 24 4.1326 24C5.7743 24 7.1052 22.6691 7.1052 21.0274C7.1052 19.3857 5.7742 18.0548 4.1326 18.0548ZM12.0054 9.04499C11.9883 9.04499 11.9712 9.04498 11.9541 9.04529C10.3046 9.13568 9.0248 10.5193 9.0631 12.1709V20.1555C9.0631 22.3225 10.0166 23.638 11.4136 23.9185C13.0254 24.2451 14.5968 23.2033 14.9234 21.5915C14.9634 21.3941 14.9834 21.1932 14.9827 20.9917V12.0332C14.9857 10.3858 13.6527 9.04799 12.0054 9.04499Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_115_4005">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <g clipPath="url(#clip0_115_4032)">
                <path
                    d="M4.1326 18.0548C2.4909 18.0548 1.16 19.3858 1.16 21.0274C1.16 22.6691 2.4909 24 4.1326 24C5.7743 24 7.1052 22.6691 7.1052 21.0274C7.1052 19.3857 5.7742 18.0548 4.1326 18.0548ZM12.0054 9.04501C11.9883 9.04501 11.9712 9.04501 11.9541 9.04531C10.3046 9.13571 9.0248 10.5193 9.0631 12.1709V20.1555C9.0631 22.3225 10.0166 23.638 11.4136 23.9185C13.0254 24.2451 14.5968 23.2033 14.9234 21.5915C14.9634 21.3941 14.9834 21.1932 14.9827 20.9917V12.0332C14.9857 10.3858 13.6527 9.04801 12.0054 9.04501Z"
                    fill="#E37400"
                />
                <path
                    d="M22.84 20.997V2.99831C22.8406 2.87741 22.8338 2.75641 22.8198 2.63631C22.6283 1.00011 21.1466 -0.170992 19.5105 0.0205078C17.9804 0.244308 16.8579 1.57471 16.8948 3.12051V20.8746C16.8576 22.4188 17.9773 23.7486 19.5053 23.9746C19.6273 23.9891 19.7501 23.9961 19.873 23.9954C21.5203 23.9867 22.8486 22.6443 22.84 20.997Z"
                    fill="#F9AB00"
                />
            </g>
            <defs>
                <clipPath id="clip0_115_4032">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
